import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Groups from './Groups'
import GroupDetail from './GroupDetail'
import NeedMoreHelp from './NeedMoreHelp'

class Main extends Component {

  constructor(props) {
    super(props)
    this.state = {
        groupID: 0,
        ipAddress: '',
        domain: '',
    };
  }

  GetPreferredDomains = () => {
    const preferredDomain1 = "my.shadowmountain.org"
    const preferredDomain2 = "localhost"
    if ((this.state.domain === preferredDomain1) || (this.state.domain === preferredDomain2)) {
      return true;        
    }
    else return false;
  }

  GetClientIP = () => {
    console.log("Main::GetClientIP");
    const _url = "https://geolocation-db.com/json/";
    fetch(_url)
    .then(response => response.json())
    .then(data => {
      this.setState({ ipAddress: data.IPv4 })
    })
  }

  componentDidMount() {
    console.log('Main::componentDidMount')
    const domain = window.location.hostname;
    if (this.state.secondaryContactGUID != null) {
      this.GetClientIP();
    }
    this.setState({
      domain: domain,
    })
}

  GroupClicked = (id) => {
    console.log("Main::GroupClickedJohn")
    this.setState({ groupID: id})
  }

  render() {
    if (this.GetPreferredDomains()) { 
    return (
        <Router>
          <Switch> 
            <Route path="/SmallGroupWidget/groups"><Groups GroupClicked={this.GroupClicked } /></Route>
            <Route path="/SmallGroupWidget/groupdetail"><GroupDetail GroupID={this.state.groupID} /></Route>
            <Route path="/SmallGroupWidget/needmorehelp"><NeedMoreHelp /></Route>
            <Route path="/SmallGroupWidget/"><Groups GroupClicked={this.GroupClicked } /></Route>
          </Switch>
        </Router>
      );
    } else {
      return (
        <div>
          bad domain
        </div>
      );
    }
  }
}

export default Main